import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import getGraphQLClient from '@graphql/client';
import saveWishMutation from '@graphql/mutations/saveWishMutation';

export const WishesContext = React.createContext();

const WishesProvider = ({
  children,
  introduction,
  wishes,
  categories,
  wishesApiKeys,
  evaluationIntro,
  wishesFormHint
}) => {
  const [countries, setCountries] = useState([]);
  const [totalWishes, setTotalWishes] = useState(0);
  const [showIntroduction, setShowIntroduction] = useState(true);
  const [activeWish, setActiveWish] = useState(null);
  const [personalWish, setPersonalWish] = useState(null);
  const [openWishDialog, setOpenWishDialog] = useState(false);
  const [openEvaluation, setOpenEvaluation] = useState(false);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetch('/static/wishes/ne_110m_admin_0_countries.geojson')
      .then(res => res.json())
      .then(({ features }) => setCountries(features));
  }, []);

  useEffect(() => {
    let maxWishes = 0;
    wishes.forEach(wish => {
      maxWishes += wish.wishedCount;
    });
    setTotalWishes(maxWishes);
  }, []);

  useEffect(() => {
    const storedState = sessionStorage.getItem('showIntroduction');
    if (storedState) {
      setShowIntroduction(JSON.parse(storedState));
    }
  }, []);

  useEffect(() => {
    sessionStorage.setItem('showIntroduction', JSON.stringify(showIntroduction));
  }, [showIntroduction]);

  const postWish = async (data, cb) => {
    const client = getGraphQLClient();
    setLoading(true);
    console.log(client);
    await client.request(saveWishMutation, data).then(res => {
      setLoading(false);

      if (res.createWish && !res.createWish.dirty) {
        setPersonalWish(null);
        setPersonalWish(res.createWish);
        cb();
      } else {
        setError(true);
      }
    });
  };

  return (
    <WishesContext.Provider
      value={{
        activeWish,
        introduction,
        countries,
        totalWishes,
        wishes,
        wishesApiKeys,
        categories,
        showIntroduction,
        openWishDialog,
        openEvaluation,
        personalWish,
        evaluationIntro,
        wishesFormHint,
        loading,
        error,
        setActiveWish,
        setPersonalWish,
        setShowIntroduction,
        setOpenWishDialog,
        setOpenEvaluation,
        postWish
      }}
    >
      {children}
    </WishesContext.Provider>
  );
};

WishesProvider.propTypes = {
  children: PropTypes.node.isRequired,
  wishesApiKeys: PropTypes.shape().isRequired,
  evaluationIntro: PropTypes.string,
  wishes: PropTypes.shape().isRequired,
  categories: PropTypes.shape().isRequired,
  wishesFormHint: PropTypes.string,
  introduction: PropTypes.shape({
    title: PropTypes.string,
    headline: PropTypes.string,
    introCopy: PropTypes.string
  }).isRequired
};

export const WishesConsumer = WishesContext.Consumer;

export default WishesProvider;
